import React, { useState } from "react";
import { Button, Tooltip, message } from "antd";
import { UserOutlined } from "@ant-design/icons";
import { CustomerEditDrawer } from "../customer-drawer/CustomerEditDrawer";
import { useCustomerProfile } from "../../viewmodels/shared/useCustomerProfile";

export function CustomerProfileButton({ phone, size = "small" }) {
  const { customer, loadByPhone, create, setCustomer } = useCustomerProfile();
  const [open, setOpen] = useState(false);
  const [loading, setLoading] = useState(false);

  const fetchAndOpen = async () => {
    if (!phone) return;
    setLoading(true);
    try {
      let found = await loadByPhone(phone);
      if (found) {
        setOpen(true);
        return;
      }
      await create({ name: phone, number: phone });
      message.success("Saved the customer automatically");
      found = await loadByPhone(phone);
      if (found) {
        setOpen(true);
      } else {
        message.error("Could not load customer profile");
      }
    } catch (e) {
      message.error(e.message || "Failed to load customer profile");
    } finally {
      setLoading(false);
    }
  };

  // A single wrapping element (not a Fragment) so this component is always
  // exactly one flex item wherever it's embedded — a Fragment here would
  // flatten the Drawer's stopPropagation div in as a second, invisible flex
  // sibling next to the button, throwing off flex layouts like
  // justifyContent: space-between in the host row.
  return (
    <span onClick={e => e.stopPropagation()} style={{ display: "inline-flex" }}>
      <Tooltip title="Open customer profile">
        <Button
          type="text"
          size={size}
          loading={loading}
          icon={<UserOutlined />}
          onClick={fetchAndOpen}
          style={{ padding: "0 4px" }}
        />
      </Tooltip>
      {/* antd's Drawer portals to document.body, but React still bubbles its
          synthetic events up the *component* tree, not the DOM tree — so any
          click inside here (closing it, editing a field, etc.) would
          otherwise reach whatever onClick the host card/row has. The outer
          span's stopPropagation covers this too. */}
      <CustomerEditDrawer
        customer={customer}
        open={open}
        defaultTab="customer"
        onClose={() => setOpen(false)}
        onSaved={updated => setCustomer(updated)}
        onFieldChanged={patch => setCustomer(current => current ? { ...current, ...patch } : current)}
      />
    </span>
  );
}
